/**
 * Hex twins of the design tokens in App.css `:root` — docs/DESIGN_SYSTEM.md.
 *
 * DOM styles use `var(--color-…)`. This exists only for the places var() cannot
 * reach: MapLibre paint properties, canvas fillStyle/strokeStyle, SVG chart props,
 * and lookup tables whose values end up in one of those. theme.test.ts pins every
 * value here to App.css, so the two cannot drift. Change one, change both.
 */
export const COLORS = {
  bgPrimary: '#0b0d10',
  bgElevated: '#0e1014',
  bgSurface: '#12151a',
  bgRaised: '#181c22',
  bgOverlay: '#1f242b',
  border: '#262b33',
  borderLight: '#333a44',
  textPrimary: '#e6e8eb',
  textSecondary: '#9aa3ae',
  textMuted: '#838c98',
  accent: '#3fb68b',
  accentHover: '#4cc498',
  accentMuted: '#2f7f63',
  onAccent: '#0b0d10',
  danger: '#f2555a',
  dangerFill: '#c4383d',
  warning: '#e3a008',
  info: '#4c9aff',
} as const;

export type ColorToken = keyof typeof COLORS;
